import { render, staticRenderFns } from "./birthday_nomination_form.vue?vue&type=template&id=1f4c39e9"
import script from "./birthday_nomination_form.vue?vue&type=script&lang=js"
export * from "./birthday_nomination_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johnmartin/Repos/whitefox-shopify-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f4c39e9')) {
      api.createRecord('1f4c39e9', component.options)
    } else {
      api.reload('1f4c39e9', component.options)
    }
    module.hot.accept("./birthday_nomination_form.vue?vue&type=template&id=1f4c39e9", function () {
      api.rerender('1f4c39e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/birthday_nomination_form.vue"
export default component.exports